import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import DoctorPaymentSetupPage from './DoctorPaymentSetupPage.js';

export default WithGASetup(DoctorPaymentSetupPage, AuthContext);
